import React, { Component } from "react";
import { search } from "../../resources/string/strings";
import { ReactComponent as IconFilter } from "../../resources/image/ic_filter.svg";
import { ReactComponent as IconClearFilter } from "../../resources/image/ic_cross.svg";
import ModalFilter from "./list-filter";

class Toolbar extends Component {
  state = {
    keyword: "",
    sortBy: "_id",
    sortType: "DESC",
    filterModalShow: false,
    filterSelectedValues: []
  };

  componentDidMount() {
    this.setState({ filterSelectedValues: this.props.filterValues })
  }

  render() {
    const { sortBy, filters } = this.props;
    return (
      <div
        className="col-12"
        style={{
          direction: "rtl",
          background: "gainsboro",
          overflow: "hidden",
          paddingRight: 16,
          paddingBottom: 8,
          paddingTop: 8,
          zIndex: 1
        }}>

        <div className="row">

          <div className="mt-1 mb-0 text-right col-11 col-sm-11 col-md-5 col-lg-5 col-xl-5">
            <div className="col ml-0 pl-0">
              <input
                style={{ paddingBottom: 3 }}
                className="form-control"
                id="keyword"
                type="text"
                placeholder={search}
                name="keyword"
                autoComplete="off"
                value={this.state.keyword}
                onChange={this.handleKeywordChange}
              />

              {this.state.keyword !== undefined && this.state.keyword.length > 0 && 
              <div style={{textAlign: "left"}}>
                <IconClearFilter
                  width={12}
                  height={12}
                  fill={`blue`}
                  alt="icon"
                  style={{ position: "fixed", cursor: `pointer`, marginTop: -25, marginRight: -24 }}
                  className="mr-0  pb-0 pt-0 clickable"
                  onClick={() => this.clearKeyword()}
               />
              </div> 
              }
            </div>
          </div>
   

              <select
                 className="mt-1 pl-0 mb-8 col-6 col-sm-5 col-md-3 col-lg-3 col-xl-2"
                rtl="true"
                style={{ 
                  height: 38,
                  direction: "rtl", 
                  right: "auto",
                  background: "white",
                  borderRadius: 6,
                  boxShadow: 0,
                  borderWidth: 1,
                  paddingLeft: 32,
                  paddingRight: 10,
                  paddingTop: 4,
                  paddingBottom: 5,
                  marginRight: 12,
                  borderColor: "lightgrey",
                  borderStyle: "solid"
                }}
                type="select"
                onChange={this.handleSortByChange}
              >

                {sortBy.map((item) => (
                  <option
                    key={item[0]}
                    value={this.state.sortBy === item}>
                    {item[0]}
                  </option>
                ))}

              </select>


          <div className="mt-1 px-0 mx-0 col-1"
            style={{
              fontSize: 30,
              color: "burlywood",
              cursor: `pointer`
            }}
            onClick={this.handleSortTypeChange}>
            {this.state.sortType === "DESC" ? `▼` : `▲`}
          </div>

          <div className="mt-1 mr-0 ml-0 px-0 col-2">
            <IconFilter
              width={30}
              height={30}
              fill={(this.props.filterValues[0] !== undefined) ? `black` : `darkgray`}
              alt="icon"
              style={{ cursor: `pointer` }}
              className="mr-0 ml-0 mt-1 pb-0 pt-0"
              onClick={this.onFilterClick}
            />

            {(this.props.filterValues[0] !== undefined) &&
              <IconClearFilter
                width={10}
                height={10}
                fill={`blue`}
                alt="icon"
                style={{ cursor: `pointer` }}
                className="mr-0 mt-0 mb-2 pb-0 pt-0"
                onClick={() => this.clearFilters()}
              />}
           
          </div>

        </div>

        <ModalFilter
          show={this.state.filterModalShow}
          onHide={this.handleFilterModalClose}
          filterchanged={this.onFilterChanged}
          filters={filters}
          values={this.state.filterSelectedValues}
          clearfilters={this.clearFilters}
        />

      </div>
    );
  }

  onFilterClick = () => {
    this.setState({ filterModalShow: true });
  };

  onFilterChanged = (item, value) => {
    var list = this.state.filterSelectedValues
    var isSet = false
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === item.id) {
        if ((value === null && value === undefined) || value === "") {
          list.splice(i, 1);
        }
        else {
          list[i].value = value
        }
        isSet = true
      }
    }
    if (!isSet) {
      if (item.type === "date") {
        list = [...list, { "id": item.id, "field": item.field, "value": value, "query": item.query, "isJalaliDate": true, "considerEndOfDay": item.considerEndOfDay }]
      }
      else {
        list = [...list, { "id": item.id, "field": item.field, "value": value, "query": item.query }]
      }
    }
    this.setState({ filterSelectedValues: list })
  };

  handleFilterModalClose = (confirm) => {
    this.setState({ filterModalShow: false });
    if (confirm) {
      this.props.filterchanged(this.state.filterSelectedValues)
    } else {
      this.setState({ filterSelectedValues: this.props.filterValues })
    }
  };

  clearFilters = () => {
    this.props.filterchanged([])
    this.setState({ filterSelectedValues: [] })
  }

  clearKeyword = () => {
    this.setState({
      keyword: ""
    });

    this.props.onSearchKeywordChanged("")
  }

  handleKeywordChange = (event) => {
    this.setState({
      keyword: event.target.value
    });

    this.props.onSearchKeywordChanged(event.target.value)
  };

  handleSortByChange = (event) => {
    const { sortBy } = this.props;
    this.setState({
      sortBy: event.target.value
    });

    this.props.onSortByChanged(sortBy[event.target.selectedIndex][1])
  };

  handleSortTypeChange = () => {
    var sortType;
    if (this.state.sortType === 'DESC') {
      sortType = 'ASC'
    } else {
      sortType = 'DESC'
    }
    this.setState({
      sortType: sortType
    });

    this.props.onSortTypeChanged(sortType)
  };
}

export default Toolbar;
